import React, {useEffect, useRef, useState} from 'react'
import {useIntl} from 'react-intl'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import {useParams} from 'react-router-dom'
import axios from 'axios'
import {Button, Col, Form, Row} from 'react-bootstrap'
import {faTrash, faXmark} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {toast} from 'react-toastify'

const dashboardBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '',
    isSeparator: false,
    isActive: false,
  },
]

const UpdateConfigurations = () => {
  const [states, setStates] = useState([])
  const [showRadioStations, setShowRadioStations] = useState(false)
  const [showPopularPod, setShowPopularPod] = useState(false)
  const [showTrendingPod, setShowTrendingPod] = useState(false)
  const [country, setCountry] = useState([])
  const [genre, setgenre] = useState([])
  const [genreType, setgenreType] = useState('')
  let imgInputRef: any = useRef([])
  let bgImgInputRef: any = useRef([])
  const [slides, setSlides] = useState([
    {
      title: '',
      subtitle1: '',
      subtitle2: '',
      imageId: null,
      imgUrl: '',
      bgImageId: null,
      bgImgUrl: '',
      navBtnText: '',
      navigate_to: '',
      country_code: '',
      state_id: '',
      genre_id: '',
    },
  ])

  let {countryCode} = useParams()

  const getConfig = async () => {
    const config = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASEURL}/config/getConfigById/`,
      {
        country_code: countryCode,
      }
    )
    if (config.data?.status == 'SUCCESS') {
      try {
        let configData = JSON.parse(config.data.data[0].configuration)
        setShowRadioStations(configData.showStations)
        setShowPopularPod(configData.showPopPod)
        setShowTrendingPod(configData.showTrendPod)
        setSlides(configData.slides)
      } catch (e) {
        setSlides([
          {
            title: '',
            subtitle1: '',
            subtitle2: '',
            imageId: null,
            imgUrl: '',
            bgImageId: null,
            bgImgUrl: '',
            navBtnText: '',
            navigate_to: '',
            country_code: '',
            state_id: '',
            genre_id: '',
          },
        ])
      }
    }
  }

  useEffect(() => {
    if (countryCode) getConfig()
  }, [countryCode])

  const getAllGenre = async (type: any) => {
    setgenreType(type)
    if (type == 'podcast') {
      const genres = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASEURL}/genre/getAllPodcastGenre/`
      )
      if (genres.data?.status == 'SUCCESS') {
        setgenre(genres.data.data)
        return
      } else {
        setgenre([])
      }
    }
    if (type == 'radio') {
      const genres = await axios.post(`${process.env.REACT_APP_BACKEND_BASEURL}/genre/getAll/`)
      if (genres.data?.status == 'SUCCESS') {
        setgenre(genres.data.data)
        // return genres
      } else {
        setgenre([])
        // return genres
      }
    } else {
      setgenre([])
    }
  }

  const getAllCountries = async () => {
    const allCountry = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASEURL}/geo-location/getAllCountry/`
    )
    if (allCountry.data?.status == 'SUCCESS') {
      setCountry(allCountry.data.data)
    } else {
      setCountry([])
    }
  }

  useEffect(() => {
    if (!countryCode) return
    getAllCountries()
  }, [countryCode])

  const handleCountrySelect = (country_code: any) => {
    const getStates = async () => {
      const states = await axios.post(
        `${process.env.REACT_APP_BACKEND_BASEURL}/geo-location/getStatesByCountryCode/`,
        {
          countryCode: country_code,
        }
      )
      if (states.data?.status == 'SUCCESS') {
        setStates(states.data.data)
      }
    }
    getStates()
  }

  const handleShowRadioStations = () => {
    setShowRadioStations(!showRadioStations)
  }

  const handleShowPopularPod = () => {
    setShowPopularPod(!showPopularPod)
  }

  const handleShowTrendingPod = () => {
    setShowTrendingPod(!showTrendingPod)
  }

  const handleSubmit = async (event: any) => {
    event.preventDefault()
    let payLoad = {
      showStations: showRadioStations,
      showPopPod: showPopularPod,
      showTrendPod: showTrendingPod,
      slides: slides,
    }
    // Handle form submission logic here using entries
    const config = await axios.post(
      `${process.env.REACT_APP_BACKEND_BASEURL}/config/updateConfig/`,
      {
        country_code: countryCode,
        conf_id: '',
        config: JSON.stringify(payLoad),
      }
    )
    if (config.data?.status == 'SUCCESS') {
      // window.alert('updated successfully')
      toast.success('Configurations Updated successfully', {
        position: 'bottom-right',
        theme: 'dark',
      })
    }
  }

  const handleInputChange = (index: any, field: any, value: any) => {
    if (field == 'title') {
      value = value.slice(0, 15)
    }

    const newEntries: any = [...slides]
    newEntries[index][field] = value
    setSlides(newEntries)
  }

  const handleImageChange = (index: any, event: any) => {
    handleRemoveImage(index)
    const newEntries: any = [...slides]
    const file = event.target.files[0]
    const reader = new FileReader()

    if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
      reader.onloadend = () => {
        // let imgId = URL.createObjectURL(file)

        const formData = new FormData()
        const uniqueFileName = `${Date.now()}_${file.name}`
        formData.append('image', file, uniqueFileName)

        const uploadImg = async () => {
          const img = await axios.post(
            `${process.env.REACT_APP_BACKEND_BASEURL}/image/ImageFolder/`,
            formData
          )
          if (img.data?.status == 'SUCCESS') {
            newEntries[index].imageId = img.data.data[0].id
            newEntries[index].imgUrl =
              `${process.env.REACT_APP_BACKEND_BASEURL}` + img.data.data[0].url
            setSlides(newEntries)
          }
        }
        uploadImg()
      }

      reader.readAsDataURL(file)
    } else {
      alert('Please upload a valid JPEG or PNG image.')
    }
  }

  const handleBgImageChange = (index: any, event: any) => {
    handleRemoveBgImage(index)
    const newSlides: any = [...slides]
    const file = event.target.files[0]
    const reader = new FileReader()

    if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
      reader.onloadend = () => {
        // let imgId = URL.createObjectURL(file)

        const formData = new FormData()
        const uniqueFileName = `${Date.now()}_${file.name}`
        formData.append('image', file, uniqueFileName)

        const uploadImg = async () => {
          const img = await axios.post(
            `${process.env.REACT_APP_BACKEND_BASEURL}/image/ImageFolder/`,
            formData
          )
          if (img.data?.status == 'SUCCESS') {
            newSlides[index].bgImageId = img.data.data[0].id
            newSlides[index].bgImgUrl =
              `${process.env.REACT_APP_BACKEND_BASEURL}` + img.data.data[0].url
            setSlides(newSlides)
          }
        }
        uploadImg()
      }

      reader.readAsDataURL(file)
    } else {
      alert('Please upload a valid JPEG or PNG image.')
    }
  }

  const handleRemoveImage = (index: any) => {
    const newSlides = [...slides]
    let imgId = newSlides[index].imageId
    if (imgId == null) return

    const removeImg = async () => {
      const img = await axios.post(`${process.env.REACT_APP_BACKEND_BASEURL}/image/DeleteById/`, {
        file_id: imgId,
      })
      if (img.data?.status == 'SUCCESS') {
        newSlides[index].imageId = null
        newSlides[index].imgUrl = ''
        if (imgInputRef.current) imgInputRef.current[index].value = ''
        setSlides(newSlides)
      }
    }
    removeImg()
  }

  const handleRemoveBgImage = (index: any) => {
    const newSlides = [...slides]
    let bgImageId = newSlides[index].bgImageId
    if (bgImageId == null) return

    const removeBgImg = async () => {
      const img = await axios.post(`${process.env.REACT_APP_BACKEND_BASEURL}/image/DeleteById/`, {
        file_id: bgImageId,
      })
      if (img.data?.status == 'SUCCESS') {
        newSlides[index].bgImageId = null
        newSlides[index].bgImgUrl = ''
        if (bgImgInputRef.current) bgImgInputRef.current[index].value = ''
        setSlides(newSlides)
      }
    }
    removeBgImg()
  }

  const handleAddSlide = () => {
    setSlides([
      ...slides,
      {
        title: '',
        subtitle1: '',
        subtitle2: '',
        imageId: null,
        imgUrl: '',
        bgImageId: null,
        bgImgUrl: '',
        navBtnText: '',
        navigate_to: '',
        country_code: '',
        state_id: '',
        genre_id: '',
      },
    ])
  }

  const handleRemoveSlide = (index: any) => {
    const newSlides = [...slides]
    newSlides.splice(index, 1)
    setSlides(newSlides)
  }

  const handleSlideExpand = (slide: any, index: any) => {
    if (slide.navigate_to == '' || !slide.navigate_to) {
      // window.alert('navigation off')
      setCountry([])
      setStates([])
      setgenre([])
      return
    }
    if (slide.navigate_to == 'radio') {
      getAllCountries()
      getAllGenre('radio')
      if (!slide.country_code) {
        setStates([])
        return
      } else {
        handleCountrySelect(slide.country_code)
      }
    }
    if (slide.navigate_to == 'podcast') {
      getAllCountries()
      getAllGenre('podcast')
      if (!slide.country_code) {
        setStates([])
        return
      } else {
        handleCountrySelect(slide.country_code)
      }
    }
  }

  return (
    <>
      {/* <PageTitle breadcrumbs={dashboardBreadCrumbs}>
        {intl.formatMessage({id: 'Region Configurations'})}
      </PageTitle>
      <UpdateRegionDetails /> */}

      {/* Header card begins */}
      <Form onSubmit={handleSubmit}>
        <div className='card p-5 mb-3'>
          <div className='regionHeadingDiv'>
            <h3 className='regionNameHeading'>Region Name - {countryCode}</h3>
            <Button className='regUpSubBtn' variant='success' type='submit'>
              Submit
            </Button>
          </div>
        </div>
        {/* Header card end */}

        {/* panel off/on setting begins */}
        <div className={`card region p-5`}>
          {/* begin::Body */}
          <div className='card-body py-3 p-0'>
            {/* begin::Table container */}
            <div className='table-responsive'>
              {/* begin::Table */}
              <table className='table align-middle gs-0 gy-3'>
                {/* begin::Table head */}
                <thead>
                  <tr>
                    {/* <th className='p-0 w-50px'></th> */}

                    <th className='text-dark fw-bold p-0' style={{fontSize: '16px'}}>
                      Home Page Configurations
                    </th>
                    <th className='text-dark fw-bold p-0 text-end' style={{fontSize: '16px'}}>
                      OFF / ON
                    </th>
                  </tr>
                </thead>
                {/* end::Table head */}
                <tbody>
                  <tr>
                    <td>
                      <a href='#' className='text-dark text-hover-primary fs-6'>
                        Show Radio Stations
                      </a>
                    </td>

                    <td className='d-flex justify-content-end'>
                      <div className='form-check form-switch form-check-custom form-check-solid me-5'>
                        <input
                          className='form-check-input h-20px w-50px toggleButton'
                          type='checkbox'
                          checked={showRadioStations}
                          value=''
                          id='flexSwitch20x30'
                          onChange={() => {
                            handleShowRadioStations()
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <a href='#' className='text-dark text-hover-primary fs-6'>
                        Show Popular Podcasts
                      </a>
                    </td>

                    <td className='d-flex justify-content-end'>
                      <div className='form-check form-switch form-check-custom form-check-solid me-5'>
                        <input
                          className='form-check-input h-20px w-50px toggleButton'
                          type='checkbox'
                          checked={showPopularPod}
                          value=''
                          id='flexSwitch20x30'
                          onChange={() => {
                            handleShowPopularPod()
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  <tr>
                    <td>
                      <a href='#' className='text-dark text-hover-primary fs-6'>
                        Show Trending Podcasts
                      </a>
                    </td>

                    <td className='d-flex justify-content-end'>
                      <div className='form-check form-switch form-check-custom form-check-solid me-5'>
                        <input
                          className='form-check-input h-20px w-50px toggleButton'
                          type='checkbox'
                          checked={showTrendingPod}
                          value=''
                          id='flexSwitch20x30'
                          onChange={() => {
                            handleShowTrendingPod()
                          }}
                        />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
              {/* end::Table */}
            </div>
            {/* end::Table container */}
          </div>
          {/* begin::Body */}
        </div>
        {/* panel off/on setting ends */}

        {/* carausel setting begins */}
        <div className='card carauselSetting p-5 mt-3'>
          <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
            <h3>Carousel Settings</h3>
            <Button variant='success' onClick={handleAddSlide}>
              + Add Slide
            </Button>
          </div>

          <div className='accordion' id='kt_accordion_1'>
            {/* <Form onSubmit={handleSubmit}> */}
            {slides?.map((slide, index) => (
              <div
                className='accordion-item'
                onClick={() => {
                  handleSlideExpand(slide, index)
                }}
              >
                <div className='d-flex justify-content-between'>
                  <h2 className='accordion-header w-100' id={`kt_accordion_1_header_${index + 1}`}>
                    <button
                      className='accordion-button fs-4 fw-bold collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target={`#kt_accordion_1_body_${index + 1}`}
                      aria-expanded='false'
                      aria-controls={`kt_accordion_1_body_${index + 1}`}
                    >
                      Slide {index + 1}
                    </button>
                  </h2>
                  {slides.length > 1 ? (
                    <FontAwesomeIcon
                      icon={faTrash}
                      onClick={() => handleRemoveSlide(index)}
                      style={{
                        paddingTop: '20px',
                        paddingRight: '20px',
                        paddingLeft: '20px',
                        color: 'red',
                        fontSize: '20px',
                      }}
                    />
                  ) : (
                    ''
                  )}
                </div>
                <div
                  id={`kt_accordion_1_body_${index + 1}`}
                  className='accordion-collapse collapse'
                  aria-labelledby={`kt_accordion_1_header_${index + 1}`}
                  data-bs-parent='#kt_accordion_1'
                >
                  <div className='accordion-body'>
                    <Row className='mb-5'>
                      <Col>
                        <Form.Group controlId={`title-${index}`}>
                          <Form.Label>Title</Form.Label>
                          <Form.Control
                            type='text'
                            placeholder='Enter title'
                            value={slide.title}
                            onChange={(e) => handleInputChange(index, 'title', e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row className='mb-5'>
                      <Col>
                        <Form.Group controlId={`subtitle1-${index}`}>
                          <Form.Label>SubTitle 1</Form.Label>
                          <Form.Control
                            type='text'
                            placeholder='Enter subtitle 1'
                            value={slide.subtitle1}
                            onChange={(e) => handleInputChange(index, 'subtitle1', e.target.value)}
                          />
                        </Form.Group>
                      </Col>

                      <Col>
                        <Form.Group controlId={`subtitle2-${index}`}>
                          <Form.Label>SubTitle 2</Form.Label>
                          <Form.Control
                            type='text'
                            placeholder='Enter subtitle 2'
                            value={slide.subtitle2}
                            onChange={(e) => handleInputChange(index, 'subtitle2', e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    {/* <Row>
                      <Col>
                        <Form.Group controlId={`subtitle2-${index}`}>
                          <Form.Label>SubTitle 2</Form.Label>
                          <Form.Control
                            type='text'
                            placeholder='Enter subtitle 2'
                            value={slide.subtitle2}
                            onChange={(e) => handleInputChange(index, 'subtitle2', e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                    </Row> */}

                    <Row className='mb-5'>
                      <Col>
                        <Form.Group controlId={`image-${index}`}>
                          <Form.Label>Image (JPEG/PNG)</Form.Label>
                          <div className='d-flex'>
                            <Form.Control
                              type='file'
                              accept='.jpg, .jpeg, .png'
                              onChange={(e) => handleImageChange(index, e)}
                              ref={(e: any) => {
                                imgInputRef.current[index] = e
                              }}
                            />
                          </div>
                          {slide.imageId && (
                            <div style={{position: 'relative'}}>
                              <FontAwesomeIcon
                                icon={faXmark}
                                style={{
                                  position: 'absolute',
                                  top: '25px',
                                  left: '460px',
                                  fontSize: '20px',
                                  color: 'white',
                                  backgroundColor: 'Red',
                                  padding: '5px',
                                  height: '20px',
                                  width: '20px',
                                  borderRadius: '10px',
                                }}
                                onClick={() => handleRemoveImage(index)}
                              />
                              <img
                                src={slide?.imgUrl ? slide?.imgUrl : ''}
                                alt={`Image ${index}`}
                                width={'500px'}
                                height={'220px'}
                                style={{
                                  marginTop: '10px',
                                  border: '1px solid #e1e3ea',
                                  borderRadius: '10px',
                                }}
                              />
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Form.Group controlId={`image-${index}`}>
                          <Form.Label>Background Image (JPEG/PNG)</Form.Label>
                          <div className='d-flex'>
                            <Form.Control
                              type='file'
                              accept='.jpg, .jpeg, .png'
                              onChange={(e) => handleBgImageChange(index, e)}
                              ref={(e: any) => {
                                bgImgInputRef.current[index] = e
                              }}
                            />
                          </div>
                          {slide.bgImageId && (
                            <div style={{position: 'relative'}}>
                              <FontAwesomeIcon
                                icon={faXmark}
                                style={{
                                  position: 'absolute',
                                  top: '25px',
                                  left: '460px',
                                  fontSize: '20px',
                                  color: 'white',
                                  backgroundColor: 'red',
                                  padding: '5px',
                                  height: '20px',
                                  width: '20px',
                                  borderRadius: '10px',
                                }}
                                onClick={() => handleRemoveBgImage(index)}
                              />
                              <img
                                src={slide.bgImgUrl ? slide.bgImgUrl : ''}
                                alt={`Image ${index}`}
                                width={'500px'}
                                height={'220px'}
                                style={{
                                  marginTop: '10px',
                                  border: '1px solid #e1e3ea',
                                  borderRadius: '10px',
                                }}
                              />
                            </div>
                          )}
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row style={{marginTop: '30px'}}>
                      <p style={{fontWeight: 600, fontSize: '15px'}}>Call To Action</p>
                    </Row>
                    <Row className='mt-2 mb-5'>
                      <Col>
                        <Form.Group controlId={`navBtnText-${index}`}>
                          <Form.Label>CTA Button Text</Form.Label>
                          <Form.Control
                            type='text'
                            placeholder={slide.navBtnText}
                            value={slide.navBtnText}
                            onChange={(e) => handleInputChange(index, 'navBtnText', e.target.value)}
                          />
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId={`title-${index}`}>
                          <Form.Label>Navigate To</Form.Label>
                          <select
                            className='form-select form-select-solid'
                            aria-label='Select example'
                            value={slide.navigate_to}
                            onChange={(e) => {
                              handleInputChange(index, 'navigate_to', e.target.value)
                              getAllGenre(e.target.value)
                            }}
                          >
                            <option value=''>None</option>
                            <option value='radio'>Radio Station</option>
                            <option value='podcast'>Podcasts</option>
                          </select>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId={`title-${index}`}>
                          <Form.Label>Region</Form.Label>
                          <select
                            className='form-select form-select-solid'
                            aria-label='Select example'
                            value={slide.country_code}
                            onChange={(e) => {
                              handleInputChange(index, 'country_code', e.target.value)
                              handleCountrySelect(e.target.value)
                            }}
                          >
                            <option value=''>Select Region</option>
                            {country
                              ? country.map((country: any) => {
                                  return (
                                    <option value={country.country_code}>
                                      {country.country_name}
                                    </option>
                                  )
                                })
                              : ''}
                          </select>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId={`title-${index}`}>
                          <Form.Label>State</Form.Label>
                          <select
                            className='form-select form-select-solid'
                            aria-label='Select example'
                            value={slide.state_id}
                            onChange={(e) => handleInputChange(index, 'state_id', e.target.value)}
                          >
                            <option value=''>All</option>
                            {states
                              ? states.map((state: any) => {
                                  return <option value={state.state_id}>{state.name}</option>
                                })
                              : ''}
                          </select>
                        </Form.Group>
                      </Col>
                      <Col>
                        <Form.Group controlId={`title-${index}`}>
                          <Form.Label>Genre</Form.Label>
                          <select
                            className='form-select form-select-solid'
                            aria-label='Select example'
                            value={slide.genre_id}
                            onChange={(e) => handleInputChange(index, 'genre_id', e.target.value)}
                          >
                            <option value=''>All</option>
                            {genre
                              ? genre.map((genre: any) => {
                                  return (
                                    <option
                                      value={
                                        genreType == 'radio'
                                          ? genre.genre_id
                                          : genre.podcast_genre_id
                                      }
                                    >
                                      {genre.name}
                                    </option>
                                  )
                                })
                              : ''}
                          </select>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </Form>
      {/* carausel setting ends */}
    </>
  )
}

export default UpdateConfigurations
